export const enToast: {
  [key: string]: { header: string; content: string; caption?: string };
} = {
  lookingForRelationshipsOrProperties: {
    header: "Looking for your relators or tropes?",
    content:
      "In Compact view, you can use relators created in other tools when creating a new relationship. Tropes are managed in concepts' detail panel",
  },
};
